var cssInstalledChunks = {};
var cssLoadingUniqueName = "@github-ui/github-ui";
function handleCssComposes(exports, composes) {
	for (var i = 0; i < composes.length; i += 3) {
		var moduleId = composes[i];
		var composeFrom = composes[i + 1];
		var composeVar = composes[i + 2];
		var composedId = __webpack_require__(composeFrom)[composeVar];
		exports[moduleId] = exports[moduleId] + " " + composedId
	}
}
var loadingAttribute = "data-rspack-loading";
var cssLoadStylesheet = (chunkId, url, done, hmr, fetchPriority) => {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == cssLoadingUniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");
if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}

link.setAttribute("data-rspack", cssLoadingUniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;

if (link.href.indexOf(window.location.origin + '/') !== 0) {
  link.crossOrigin = 'anonymous';
}


	}
	var onLinkComplete = (prev, event) => {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load" && link.parentNode) link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	if (hmr && hmr.getAttribute("fetchpriority")) link.setAttribute("fetchpriority", hmr.getAttribute("fetchpriority"));
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
__webpack_require__.f.css = (chunkId, promises, fetchPriority) => {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(cssInstalledChunks, chunkId)
		? cssInstalledChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (/^(m([01bc]|0x|1s|4p|a2|ef|ft|hm|j3|ot|pe|qe|qi)|n([37bi]||0k|23|2u|57|95|ac|c5|do|jx|ml|qa|ya|ze)|2(57|5k|77|7y|8|ci|d6|g3|hd|k4|s)|f([69flmwx]|2j|44|4t|bm|d3|n4|n7|ob|pr|rd|sl|to|tw|vi|wi|wn)|q([145bwx]|4j|g9e|j7|k4|mc|tf|v0)|w([7agj]|0q|1v|57|a6|cf|ry|s7|v4|wb5)|z([0agktw]|51|bi|dw|f4|me|mu|x5)|o([148iux]|z[ack]|4n|4q|dj|f6|fo|hu|uh|wz)|k([39efj]|ya(|a)|1f|1z|4h|54|89|jb|me|q9|qz|r2|zb)|d([59eik]|30|cm|f6|gb|nc|pi|v7|yf|ze)|l(b|b0|cd|d|h5|iy|u0|ym)|7([adju]|2a|2d|5z|86|a2|b3|fa|gn|ie|w3)|b((|o|s)c|3t|84|am|kn|vx|xt|z)|9([3aglq]|1u|65|87|9u|be|bi|e6|j2|ls|mq|og|p9)|r([9cgjw]|02|6j|7a|hk|ku|n6|oo|q7|xd|za|zx)|0([djpw]|1[5kq]|4y|92|ag|aj|bc|gn|ig|q9|vb|xz|yx)|t(l(3|7|lv)|3a|3w|51|7lm|a6|ah|c|db|gm|ii|n|n9|q8|qs|uc|ue)|i([15ou]|r[4iz]|4i|99|a2|ap|b6|c0|gs|ix|k4|kr|lwb|nj|ns|w6)|x([9jluyz]|2y|4x|a3|bg|bv|gd|hy|mx|rh|yc|zc)|h([16x]|a[58o]|4b|cx|g2|gj|j6|t8|up|wz|ya|yz)|j([4ciqv]|29|7g|9p|a4|dp|dv|pn|wb|wf)|3([5ez]|71|92|fl|j3|r4|wj)|s([37bcglr]|0a|61|d9|ex|he|hs|kd|kj|me|tz|vp)|v([9afs]|k[dhn]|b3|ct|fa|n4|og)|1([178fiotw]|00|96|f1|iz|jf|mh|mu|rv|x7)|8([2ehw]|1s|e8|es|gu|hi|k2|nm|ov|qc|w4|xc)|g([179x]|yb|yf|zt)|p([2ds]|3x|6o|n8|v3|yv)|4([1nv]|7[6eh]|17|2a|bi|eg|ft|hs|jx|uu|v5)|a([267fw]|2r|3u|7y|9o|ck|cv|do|eb|ez|ik|jn|k3|rf)|5([456mu]|0s|1p|6n|kk|rd|s9)|c([48k]|23|4t|8a|mi|n9)|6([3coquvyz]|19|3t|8y|96|cd|fq|gc|v8|vyp|wr)|u((|u|w)8|2l|dt|gm|hn|wq)|e([5fhlrw]|2b|2f|40|98|ah|av|l9|mz|tb|tk3|vi|vw|wc|wo)|y([cjky]|2q|7n|ek|l8|zx))$/.test(chunkId)) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = cssInstalledChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(cssInstalledChunks, chunkId)) {
						installedChunkData = cssInstalledChunks[chunkId];
						if (installedChunkData !== 0) cssInstalledChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								cssInstalledChunks[chunkId] = 0;
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					cssLoadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else cssInstalledChunks[chunkId] = 0;
		}
	}
};
